import { AsyncComponent } from '@frontend/components/mobile';
import { lazy } from 'react';
import { Route } from 'react-router-dom';

const ItemDetail = lazy(() => import('./item-detail/item-detail.component'));
const Items = lazy(() => import('./items.component'));

export function ItemsRoutes() {
    return (
        <Route path='items'>
            <Route
                index
                element={
                    <AsyncComponent>
                        <Items />
                    </AsyncComponent>
                }
            />
            <Route path=':itemId'>
                <Route
                    path='detail'
                    element={
                        <AsyncComponent>
                            <ItemDetail />
                        </AsyncComponent>
                    }
                />
            </Route>
        </Route>
    );
}
